import { Vector2 } from "./vector2.js";

export const Constants = (function () {
    return {
        SERVER_WS_URL: 'wss://maincloud.spacetimedb.com',
        GLOBAL_DB_NAME: 'geometry-core',
        // GLOBAL_DB_NAME: 'c200916f08975cf8fbe1a4c99dd7e2d23b7ef07aa6c5c69b5178c12490ed50cc',
        DEBUG_MODE: false,
        ORIGIN: 'http://localhost:5173'
    } as const;
})();